import React, { useEffect, useState } from "react";
import { FiAlignJustify } from "react-icons/fi";
import { FiSearch } from "react-icons/fi";
import { useStateContext } from "context/ContextProvider.jsx";
import { useLocation } from "react-router-dom";
import UserDropdown from "components/UserDropdown";

const Navbar = (props) => {
    const { onOpenSidenav, brandText } = props;
    const { setSearchValue } = useStateContext();
    const location = useLocation();
    const [search, setSearch] = useState(false);
    useEffect(() => {
        setSearch(
            [
                "/my/activation-history",
                "/my/pending-activations",
                "/my/servers",
                "/my/domains",
                "/my/new-activation",
            ].includes(location.pathname)
        );
    }, [location]);

    const handleChange = (event) => {
        const value = event.target.value;
        if (value?.length >= 3) {
            setSearchValue(value);
        } else {
            setSearchValue("");
        }
    };

    return (
        <nav className="z-40 flex flex-row flex-wrap items-center justify-between rounded-xl bg-white/10 py-2 px-1 dark:bg-[#0b14374d]">
            <div className="ml-[6px] mt-[25px] mb-[-5px]">
                <p className="shrink text-[33px] font-bold capitalize text-gray-800 dark:text-white">
                    {brandText}
                </p>
            </div>

            <div className="relative mt-[3px] flex h-[61px] w-[355px] flex-grow items-center justify-around gap-2 rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:w-[365px] md:flex-grow-0 md:gap-1 xl:w-[365px] xl:gap-2">
                <div
                    className={
                        search
                            ? "flex-2 flex h-full items-center rounded-full bg-lightPrimary text-navy-700 dark:bg-navy-900 dark:text-white xl:w-[225px]"
                            : "flex-2 flex h-full cursor-not-allowed items-center rounded-full bg-lightPrimary text-navy-700 dark:bg-navy-900 dark:text-white xl:w-[225px]"
                    }
                >
                    <p
                        style={{ opacity: search ? 1 : 0.4 }}
                        className="pl-3 pr-2 text-xl"
                    >
                        <FiSearch className="h-4 w-4 text-gray-800 dark:text-white" />
                    </p>
                    <input
                        type="text"
                        placeholder={search ? "Ricerca" : ""}
                        disabled={!search}
                        onChange={handleChange}
                        className={
                            search
                                ? "block h-full w-full rounded-full bg-gray-50 text-sm font-medium text-gray-800 outline-none placeholder:!text-gray-600 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white sm:w-fit"
                                : "block h-full w-full cursor-not-allowed rounded-full bg-gray-50 text-sm font-medium text-gray-800 outline-none placeholder:!text-gray-600 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white sm:w-fit"
                        }
                    />
                </div>
                <span
                    className="flex flex-1 cursor-pointer fill-gray-800 text-xl dark:text-white xl:hidden"
                    onClick={onOpenSidenav}
                >
                    <FiAlignJustify className="h-5 w-5" />
                </span>
                {/* <div
                    className="cursor-pointer fill-gray-800"
                    onClick={toggleModal}
                >
                    <LogoutIcon />
                </div> */}
                {/* <div className="cursor-pointer fill-gray-800">
                    <Link key={"change-password"} to={"/my/change-password"}>
                        <ProfileIcon />
                    </Link>
                </div> */}
                <UserDropdown />
            </div>
        </nav>
    );
};

export default Navbar;
